export const productPath = (p) => `/urun/${p.seo_slug || p.urun_id}`;
export const categoryPath = (c) => (c?.seo_slug ? `/kategori/${c.seo_slug}` : `/urunler?kategori=${c?.kategori_id}`);
export const HIDDEN_BRANDS = ["Marka Teklifte Belirtilecek"];
// Tek ana adres: canonical, JSON-LD ve breadcrumb her zaman www kökünü kullanır
export const SITE_ORIGIN = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");

export const ORG = {
  name: "MOLAR KİMYA GIDA SAN ve TİC A.Ş.",
  telephone: "+90 533 272 71 26",
  email: "molarkimya@molarkimya.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "SARIGÜLLÜK MAH. 61041 SK. SEDEF APT. NO: 12 A",
    addressLocality: "Şehitkamil",
    addressRegion: "Gaziantep",
    addressCountry: "TR",
  },
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem", position: i + 1, name: it.name, item: SITE_ORIGIN + it.path,
  })),
});
